import { render, staticRenderFns } from "./RewardsProgram.vue?vue&type=template&id=170cf2cb&scoped=true"
import script from "./RewardsProgram.vue?vue&type=script&lang=js"
export * from "./RewardsProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170cf2cb",
  null
  
)

export default component.exports